import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spinners" }
const _hoisted_2 = { class: "spinners-icons" }
const _hoisted_3 = { class: "spinners-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FontAwesomeIcon, {
        class: "spinner-1",
        icon: _ctx.faGear
      }, null, 8, ["icon"]),
      _createVNode(_component_FontAwesomeIcon, {
        class: "spinner-2",
        icon: _ctx.faGear
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
  ]))
}